// src/components/Blocks/TCEvents/Edit.jsx

import React from 'react';
import { SidebarPortal } from '@plone/volto/components';
import InlineForm from '@plone/volto/components/manage/Form/InlineForm';
import TCEventsView from './View';
import schema from './Schema';

const TCEventsEdit = ({ block, data, onChangeBlock, selected }) => {
  return (
    <>
      <TCEventsView data={data} />

      <SidebarPortal selected={selected}>
        <InlineForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          formData={data}
        />
      </SidebarPortal>
    </>
  );
};

export default TCEventsEdit;
